import gql from 'graphql-tag'

export const WeldPartsFragment = gql`
  fragment WeldParts on Weld {
    id
    no
    weld_joint_type {
      weld_type {
        id
        name
      }
      joint_type {
        id
        name
      }
    }
    length
    thickness_1
    thickness_2
    material_1 {
      id
      designation_name
    }
    material_2 {
      id
      designation_name
    }
    diameter_1
    diameter_2
    welding_progress
    has_dimensional_control
    dc_weld_failed
    inspections
    failed_inspections
    inspection_groups
    extra_data
    status
    welder {
      person {
        id
        last_name
        uuid
      }
      date
      wps_no
    }
    welding_consumables {
      id
      name
    }
    project {
      id
      name
    }
    wps {
      id
      no
      rev_no
      welder_certification_standards
    }
    inspection_category {
      id
      inspections {
        type_id
        double_length
      }
    }
    blocked_for_import
  }
`

export const WeldsFetchQuery = gql`
  query WeldsFetchQuery($project_id: ID!, $include_project_descendants_welds: Boolean,
                        $pageSize: Int = 500, $page: Int = 1, $filters: WeldFilterInput) {
    welds(project_id: $project_id, include_project_descendants_welds: $include_project_descendants_welds,
          page: $page, size: $pageSize, filters: $filters) {
      list {
        ...WeldParts
      }
      metadata {
        total_count
        total_pages
        prev_page
        current_page
        next_page
      }
    }
  }
${WeldPartsFragment}
`

export const createOrUpdateWeldsMutation = gql`
  mutation createOrUpdateWelds (
    $id: ID,
    $project_id: Int!,
    $no: String,
    $weld_joint_type: [WeldJoinInputType],
    $length: Int,
    $thickness_1: Float,
    $thickness_2: Float,
    $material_1_id: Int,
    $material_2_id: Int,
    $diameter_1: Float,
    $diameter_2: Float,
    $wps_id: [Int],
    $inspection_category_id: Int,
    $extra_data: String
  ) {
    createOrUpdateWelds (
      id: $id,
      project_id: $project_id,
      no: $no,
      weld_joint_type: $weld_joint_type,
      length: $length,
      thickness_1: $thickness_1,
      thickness_2: $thickness_2,
      material_1_id: $material_1_id,
      material_2_id: $material_2_id,
      diameter_1: $diameter_1,
      diameter_2: $diameter_2,
      wps_id: $wps_id,
      inspection_category_id: $inspection_category_id,
      extra_data: $extra_data
    ) {
      weld {
        ...WeldParts
      }
      errors
    }
  }
${WeldPartsFragment}
`

export const destroyWeldsMutation = gql`
  mutation destroyWelds($id: ID, $ids: [ID], $permanent: Boolean) {
    destroyWelds(id: $id, ids: $ids, permanent: $permanent) {
      response
    }
  }
`

export const toggleBlockWeldMutation = gql`
  mutation toggleBlockWeld($id: ID!) {
    toggleBlockWeld(id: $id) {
      weld {
        ...WeldParts
      }
      errors
    }
  }
${WeldPartsFragment}
`



// WEBPACK FOOTER //
// ./src/components/Welds/mutations.js